import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import 'react-phone-input-2/lib/bootstrap.css'
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components'
import Select from 'react-select';
import { fetchData, fetchFormData, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../../reusable'
import { ToastContainer } from 'react-toastify'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { Tr } from '../../../../_metronic/i18n/Tr'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'

export function Registration() {
  const t = Tr();
  const lang = useLang()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [profilePicture, setProfilePicture] = useState();
  const [fullName, setFullName] = useState("");
  const [countryCode, setCountryCode] = useState('uz');
  const [mobileNumber, setMobileNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [referralCode, setReferralCode] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordDisplay, setPasswordDisplay] = useState(false)
  const [confirmPasswordDisplay, setConfirmPasswordDisplay] = useState(false)

  // category list state start
  const [categoryList, setCategoryList] = useState([]);
  const [categorySelectedOptions, setCategorySelectedOptions] = useState<any>([]);
  var categoryId = categorySelectedOptions.value;

  // category list state end
  // set error state
  const [error, setError] = useState([{
    profilePicture: '',
    fullName: '',
    phoneNumber: '',
    email: '',
    password: '',
    confirmPassword: '',
    categoryId: '',
  }])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }

  const handleChange = (value: any, country: any, e: any, formate: any) => {

    setPhoneNumber(value); // set mobile number default value
    removeError("phoneNumber"); // remove error message
    const parts = formate.split(' ');
    const formattedValue = parts.slice(1).join(' ').replace(/\D/g, "");
    setCountryCode(country.dialCode); // get country code
    setMobileNumber(formattedValue); // get mobile number without country code

  };
  const validate = () => {

    var isValid = true;
    var errorTmp = [...error];
    let firstErrorField = null;

    if (profilePicture == undefined || profilePicture == null || profilePicture == undefined) {
      errorTmp[0].profilePicture = t('Profile picture is required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'profilePicture';

    }
    if (fullName == "" || fullName == null || fullName == undefined) {
      errorTmp[0].fullName = t('Full Name is required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'fullName';
    }
    if (categorySelectedOptions == "" || categorySelectedOptions == null || categorySelectedOptions == undefined) {
      errorTmp[0].categoryId = t('Category is required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'categoryId';
    }
    if (phoneNumber == "" || phoneNumber == undefined || phoneNumber == null) {
      errorTmp[0].phoneNumber = t('Mobile Number is required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'phoneNumber';

    } else if (!Number(phoneNumber)) {
      errorTmp[0].phoneNumber = t('Only Numbers is allowed.');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'phoneNumber';

    } else if ((phoneNumber != "" && phoneNumber != undefined || phoneNumber != null) && phoneNumber.length < 8) {
      errorTmp[0].phoneNumber = t('Minimum 8 Digit Required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'phoneNumber';
    }
    if (email == "" || email == undefined || email == null) {
      errorTmp[0].email = t('Email is required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'email';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
      errorTmp[0].email = t('Please enter valid email.');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'email';
    }
    if (password == "" || password == undefined || password == null) {
      errorTmp[0].password = t('Password is required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'password';
    } else if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/.test(password)) {
      errorTmp[0].password = t('Use 8 or more characters with a mix of letters, numbers & symbols.');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'password';
    }
    if (confirmPassword == "" || confirmPassword == null || confirmPassword == undefined) {
      errorTmp[0].confirmPassword = t('Confirm Password is required');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'confirmPassword';

    } else if (password != confirmPassword) {
      errorTmp[0].confirmPassword = t('Password and Confirm Password are not matched');
      isValid = false;
      if (!firstErrorField) firstErrorField = 'confirmPassword';
    }

    setError(errorTmp);
    // If there was a validation error, scroll to the first error field
    if (!isValid && firstErrorField) {
      const element = document.getElementById(firstErrorField);
      if (element) {
        element?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    return isValid;
  }

  const registrationApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param = new FormData()
      param.append('fullName', fullName)
      param.append('categoryId', categoryId)
      param.append('countryCode', countryCode)
      param.append('mobileNumber', mobileNumber)
      param.append('email', email)
      param.append('referralCode', referralCode)
      param.append('password', password)
      if (profilePicture) {
        param.append('logo', profilePicture)
      }
      var res = await fetchFormData("public/register", param)
      if (res.status == "200") {
        var data = res.data;

        toastsuccessmsg(t("Registration Successfully"))
        const state = {
          vendorId: data['vendorId']
        }
        setTimeout(() => {
          setDisable(false)
          setLoading(false)
          navigate("../personaldetails/", { state });
        }, 1500);
      }
      else {
        toasterrormsg(res.message)
        setDisable(false)
        setLoading(false)
      }
    }

  }

  //  category list api call
  const categoryAPIcall = async () => {

    var res = await fetchData("public/categoryList", [])

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.categoryId, label: getTranslatedValue(lang, val, '_name') })
      })
      console.log(res.data);
      

      setCategoryList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  useEffect(() => {
    PasswordMeterComponent.bootstrap()
    categoryAPIcall()
  }, [])

  return (
    <>
      <ToastContainer />
      <div
        className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
        id='kt_login_signup_form'
      // noValidate
      // onSubmit={formik.handleSubmit}
      >
        {/* begin::Heading */}
        <div className='text-center mb-11'>
          {/* begin::Title */}
          <h1 className='text-dark fw-bolder mb-3'>{t('Sign Up')}</h1>
          {/* end::Title */}
        </div>
        {/* end::Heading */}

        {/* <!--begin::Input group--> */}
        <div className="row mb-8">
          {/* <!--begin::Col--> */}
          <div className="col-lg-12">
            {/* <!--begin::Image input--> */}
            <div className="image-input image-input-outline " data-kt-image-input="true" id='profilePicture'>
              {/* <!--begin::Preview existing avatar--> */}
              <img id="previewImage" className="image-input-wrapper w-125px h-125px changeimg pointer" src={profilePicture ? URL.createObjectURL(profilePicture) : imageUrl === "" || imageUrl === null ? toAbsoluteUrl("/media/avatars/300-1.jpg") : imageUrl} />
              {/* <!--end::Preview existing avatar--> */}
              {/* <!--begin::Label--> */}
              <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow" data-kt-image-input-action="change" data-bs-toggle="tooltip" title="" data-bs-original-title="Change avatar">
                <i className="fa fa-edit"></i>
                {/* <!--begin::Inputs--> */}
                <input type="file" name="image" id="profileImage" accept=".png, .jpg, .jpeg" style={{ "display": "none" }} onChange={(e: any) => { if (e.target.files[0] != null && e.target.files[0] != undefined) { setProfilePicture(e.target.files[0]); removeError('profilePicture') } }} />
                <input type="hidden" name="avatar_remove" />
                {/* <!--end::Inputs--> */}
              </label>
              {/* <!--end::Label--> */}
            </div>
            {/* <!--end::Image input--> */}
            {/* <!--begin::Hint--> */}
            <div className="form-text" id="validimage">{t('Allowed file types: png, jpg, jpeg.')}</div>
            {/* <!--end::Hint--> */}
            <div className='text-danger fw-bold'>{error[0].profilePicture}</div>
          </div>
          {/* <!--end::Col--> */}
        </div>
        {/* <!--end::Input group--> */}
        {/* begin::Form group Firstname */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Full Name')}</label>
          <input
            placeholder={t('Full Name')}
            type='text'
            id='fullName'
            autoComplete='off'
            className='form-control bg-transparent'
            value={fullName}
            onChange={(e: any) => { setFullName(e.target.value); removeError("fullName"); }}
          />
          <div className='text-danger fw-bold'>{error[0].fullName}</div>
        </div>
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Select Your Service')}</label>
          <Select
            name='category[]'
            id='categoryId'
            placeholder={t('Select Your Service')}
            isSearchable={true}
            options={categoryList}
            value={categorySelectedOptions}
            onChange={(e: any) => { setCategorySelectedOptions(e); removeError("categoryId"); }}
          />
          {/* <!--end::Input--> */}
          <div className='text-danger fw-bold'>{error[0].categoryId}</div>
        </div>
        {/* end::Form group */}
        <div className='fv-row mb-8'>
          {/* begin::Form group Lastname */}
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Mobile Number')}</label>
          <div id='phoneNumber'>
            <PhoneInput
              inputClass="form-control form-control-solid w-100"
              placeholder={t('Enter Mobile Number')}
              enableSearch={true}
              value={phoneNumber}
              country={countryCode}
              onChange={handleChange}
            />
          </div>
          {/* end::Form group */}
          <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
        </div>

        {/* begin::Form group Email */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Email')}</label>
          <input
            placeholder={t('Enter Email')}
            type='email'
            id='email'
            autoComplete='off'
            className='form-control bg-transparent'
            value={email}
            onChange={(e: any) => { setEmail(e.target.value); removeError("email"); }}
          />
          <div className='text-danger fw-bold'>{error[0].email}</div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Password */}
        <div className='fv-row mb-8' data-kt-password-meter='true'>
          <div className='mb-1'>
            <label className='form-label fw-bolder text-dark fs-6 required'>{t('Password')}</label>
            <div className='position-relative mb-3'>
              <input
                type={passwordDisplay == true ? "text" : "password"}
                placeholder={t('Password')}
                id='password'
                autoComplete='off'
                className='form-control bg-transparent'
                value={password}
                onChange={(e: any) => { setPassword(e.target.value); removeError("password"); }}
              />
              <span className="cursor-pointer" style={{ position: "absolute", top: "25%", right: "20px" }} title={passwordDisplay == true ? "Hide" : "Show"} onClick={() => setPasswordDisplay(!passwordDisplay)}><FontAwesomeIcon icon={passwordDisplay == true ? faEyeSlash : faEye} /></span>
              <div className="fv-plugins-message-container invalid-feedback"></div>
              <div className='text-danger fw-bold'>{error[0].password}</div>
            </div>
            {/* begin::Meter */}
            <div
              className='d-flex align-items-center mb-3'
              data-kt-password-meter-control='highlight'
            >
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
              <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
            </div>
            {/* end::Meter */}

          </div>
          <div className='text-muted'>
            {t('Use 8 or more characters with a mix of letters, numbers & symbols.')}
          </div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Confirm password */}
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6 required'>{t('Confirm Password')}</label>
          <div style={{ position: "relative" }}>
            <input
              type={confirmPasswordDisplay == true ? "text" : "password"}
              placeholder={t('Confirm Password')}
              id='confirmPassword'
              autoComplete='off'
              className='form-control bg-transparent'
              value={confirmPassword}
              onChange={(e: any) => { setConfirmPassword(e.target.value); removeError("confirmPassword"); }}
            />
            <span className="cursor-pointer" style={{ position: "absolute", top: "25%", right: "20px" }} title={confirmPasswordDisplay == true ? "Hide" : "Show"} onClick={() => setConfirmPasswordDisplay(!confirmPasswordDisplay)}><FontAwesomeIcon icon={confirmPasswordDisplay == true ? faEyeSlash : faEye} /></span>
            <div className="fv-plugins-message-container invalid-feedback"></div>
          </div>
          <div className='text-danger fw-bold'>{error[0].confirmPassword}</div>
        </div>
        {/* end::Form group */}

        {/* begin::Form group Email */}
        <div className='fv-row mb-8'>
          <label className='form-label fw-bolder text-dark fs-6'>{t('Referral Code (Optional)')}</label>
          <input
            placeholder={t('Referral Code')}
            type='referralCode'
            id='referralCode'
            autoComplete='off'
            className='form-control bg-transparent'
            value={referralCode}
            onChange={(e: any) => { setReferralCode(e.target.value); }}
          />
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className='text-center'>
          <button type="button" disabled={disable} className="btn btn-lg btn-primary w-100 mb-5" onClick={registrationApi}>
            <span className="indicator-label">{t('Submit')}</span>
            {loading && (
              <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
            )}
          </button>
          <Link to='/auth/login'>
            <button
              type='button'
              id='kt_login_signup_form_cancel_button'
              className='btn btn-lg btn-light-primary w-100 mb-5'
            >
              {t('Cancel')}
            </button>
          </Link>
        </div>
        {/* end::Form group */}
      </div>
    </>
  )
}
